import React from "react";
import { Box, Avatar, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import { IconSearch, IconMenu2 } from "@tabler/icons-react";
import { paths } from "../../../routes/paths";
import { useConsole } from "../../pages/Console/ConsoleContext";
import logo from "../../../assets/new_logo.png";
import tokens from "../../theme/tokens";

const { color, font, layout, radius } = tokens;

/**
 * The ⌘K chip is presentational for now — the command bar itself is a later phase.
 */
const ConsoleTopBar = ({ user, onOpenRail }) => {
  const { setCommandOpen } = useConsole();
  const initials = [user?.firstName, user?.lastName]
    .filter(Boolean)
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  return (
    <Box
      component="header"
      sx={{
        height: layout.topBar,
        flex: "none",
        display: "flex",
        alignItems: "center",
        gap: 2,
        px: 2,
        bgcolor: color.surface,
        borderBottom: `1px solid ${color.border}`,
      }}
    >
      <IconButton
        size="small"
        onClick={onOpenRail}
        sx={{ display: { xs: "inline-flex", md: "none" } }}
        aria-label="Open jobs"
      >
        <IconMenu2 size={18} stroke={1.75} color={color.textSecondary} />
      </IconButton>

      <Link to={paths.v1.jobs}>
        <Box
          component="img"
          src={logo}
          alt="Hire-Best.ai"
          sx={{ width: { xs: 96, md: 104 }, display: "block" }}
        />
      </Link>

      {/* Desktop: a full-width field that opens the ⌘K palette. It's a button, not an
          input — all searching happens inside the palette. */}
      <Box
        onClick={() => setCommandOpen(true)}
        sx={{
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          gap: 1,
          width: 340,
          mx: "auto",
          px: 1.5,
          py: 0.75,
          cursor: "pointer",
          bgcolor: "#F2F2F5",
          border: `1px solid ${color.border}`,
          borderRadius: `${radius.control}px`,
          font: `400 12.5px ${font.sans}`,
          color: color.textMuted,
          "&:hover": { borderColor: color.borderInput },
        }}
      >
        <IconSearch size={16} stroke={1.75} color={color.textMuted} />
        <Box sx={{ flex: 1 }}>Search candidates, jobs, actions…</Box>
        <Box
          component="kbd"
          sx={{
            font: `500 10.5px ${font.mono}`,
            bgcolor: color.surface,
            border: `1px solid ${color.borderInput}`,
            borderRadius: `${radius.chip}px`,
            px: 0.625,
            py: "1px",
            color: "#6E6E78",
          }}
        >
          ⌘K
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1.75, ml: { xs: "auto", md: 0 } }}>
        {/* Below md the search collapses to an icon. */}
        <IconButton
          size="small"
          onClick={() => setCommandOpen(true)}
          sx={{ display: { xs: "inline-flex", md: "none" } }}
          aria-label="Search"
        >
          <IconSearch size={18} stroke={1.75} color={color.textSecondary} />
        </IconButton>

        {/* Resume Pool is hidden: its search is RAG-backed and needs Neo4j, which isn't
            deployed yet. The route still resolves — restore this link to bring it back. */}
        <Avatar
          sx={{
            width: 28,
            height: 28,
            bgcolor: color.indigoTint,
            color: color.indigo,
            font: `600 11px ${font.sans}`,
          }}
        >
          {initials || "?"}
        </Avatar>
      </Box>
    </Box>
  );
};

export default ConsoleTopBar;
